// src/components/common/CookieConsent.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { cookieService } from '../../services/cookieService';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    setShowConsent(!cookieService.hasConsent());
  }, []);

  const saveAndClose = (nextPreferences) => {
    cookieService.setConsent(true);
    cookieService.setPreferences({ ...nextPreferences, necessary: true });
    setShowConsent(false);
  };

  const handleAcceptAll = () => {
    saveAndClose({
      necessary: true,
      functional: true,
      analytics: true,
      marketing: false
    });
  };

  const handleEssentialOnly = () => {
    saveAndClose({
      necessary: true,
      functional: false,
      analytics: false,
      marketing: false
    });
  };

  if (!showConsent) return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-50 sm:inset-x-auto sm:right-4 sm:max-w-md">
      <div className="relative overflow-hidden rounded-2xl border border-eduvibe-blue/25 bg-[#031329]/94 p-4 text-white shadow-[0_18px_54px_rgba(0,0,0,0.38)] backdrop-blur-xl">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_12%_0%,rgba(47,234,155,0.18),transparent_32%),radial-gradient(circle_at_88%_20%,rgba(82,212,242,0.16),transparent_30%)]" />
        <div className="relative">
          <div className="flex gap-3">
            <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl border border-eduvibe-green/35 bg-eduvibe-green/10 text-eduvibe-green">
              <Cookie className="h-5 w-5" aria-hidden="true" />
            </span>
            <div className="min-w-0">
              <h2 className="text-base font-black leading-tight text-white">
                Cookies, kept simple
              </h2>
              <p className="mt-1 text-xs leading-5 text-white/72">
                Essentials keep EduVibz secure. Optional cookies help us improve what learners use. No ads. No selling your data.
              </p>
              <Link to="/cookie-policy" className="mt-1 inline-flex text-xs font-bold text-eduvibe-green hover:text-eduvibe-blue">
                Cookie policy
              </Link>
            </div>
          </div>

          <div className="mt-4 grid grid-cols-2 gap-2">
            <button
              type="button"
              onClick={handleEssentialOnly}
              className="inline-flex min-h-11 items-center justify-center rounded-full border border-eduvibe-blue/40 px-4 py-2 text-sm font-extrabold text-white transition hover:border-eduvibe-green/60"
            >
              Essential only
            </button>
            <button
              type="button"
              onClick={handleAcceptAll}
              className="inline-flex min-h-11 items-center justify-center rounded-full bg-eduvibe-green px-4 py-2 text-sm font-extrabold text-eduvibe-dark shadow-[0_0_24px_rgba(47,234,155,0.22)] transition hover:bg-white"
            >
              Accept all
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
